export default {
  disengaged: 'DISENGAGED',
  engaged: 'ENGAGED',
  off: 'OFF',
  on: 'ON',
  unavailable: 'UNAVAILABLE',
}
